// src/jira-servicedesk/queue/types.ts
var JiraServicedeskQueueAriResourceOwner = "jira-servicedesk", JiraServicedeskQueueAriResourceType = "queue";

export {
  JiraServicedeskQueueAriResourceOwner,
  JiraServicedeskQueueAriResourceType
};
